import { formatAge } from './display-time'

/** #876: the fields the API puts on every row (queue, case lists, Home, search) for a reply this person has not seen. */
export interface UnreadFields {
  unread?: boolean
  unread_kind?: 'customer' | 'contractor' | null
  unread_at?: string | null
}

/** Row prop for `QueueRow`/Home/search: the "New reply · 5 min ago" label, or undefined when the row is read. */
export function unreadOf(row: UnreadFields, now = Date.now()): { label: string; kind: 'customer' | 'contractor' } | undefined {
  if (!row.unread) return undefined
  const kind = row.unread_kind ?? 'customer'
  const age = row.unread_at ? formatAge(row.unread_at, now) : ''
  const base = kind === 'contractor' ? 'New contractor reply' : 'New reply'
  return { label: age ? `${base} · ${age}` : base, kind }
}
